const PRICE_FORMATTER = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (value: number): string => {
  if (!Number.isFinite(value)) {
    return '—';
  }

  return PRICE_FORMATTER.format(value);
};

export const formatDateTick = (ms: number, spanMs: number): string => {
  if (!Number.isFinite(ms) || !Number.isFinite(spanMs)) {
    return '—';
  }

  const d = new Date(ms);

  if (spanMs <= 1000 * 60 * 60 * 24 * 2) {
    return d.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC',
    });
  }

  if (spanMs <= 1000 * 60 * 60 * 24 * 365 * 1.2) {
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      timeZone: 'UTC',
    });
  }

  return d.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

// Cached because `Intl.DateTimeFormat` construction is non-trivial
// and `formatTooltipTime` runs on every crosshair pointer-move frame.
const TOOLTIP_WEEKDAY = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  timeZone: 'UTC',
});
const TOOLTIP_MONTH = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  timeZone: 'UTC',
});
const TOOLTIP_TIME = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'UTC',
});

/**
 * Mirrors v1's `formatXAxisPoint` so the chartv2 crosshair label reads
 * the same as the legacy chart, e.g. `Thu 26 Mar'26` (or
 * `Thu 26 Mar'26 14:30` for intraday). UTC-locked because all chartv2
 * data is treated as UTC; consumers that need localised tz formatting
 * can render their own tooltip via the existing tooltip API.
 */
export const formatTooltipTime = (ms: number): string => {
  if (!Number.isFinite(ms)) {
    return '—';
  }

  const d = new Date(ms);
  const weekday = TOOLTIP_WEEKDAY.format(d);
  const day = d.getUTCDate();
  const month = TOOLTIP_MONTH.format(d);
  const yy = (d.getUTCFullYear() % 100).toString().padStart(2, '0');
  const base = `${weekday} ${day} ${month}'${yy}`;

  // Drop the `HH:mm` suffix on day-aligned ticks — v1 only appends it
  // when the timestamp doesn't fall on a 00:00 boundary.
  if (d.getUTCHours() === 0 && d.getUTCMinutes() === 0) {
    return base;
  }

  return `${base} ${TOOLTIP_TIME.format(d)}`;
};
